export default {
  "loading": "Cargando !!!"
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/loading/index.js